module.exports = __webpack_public_path__ + "static/media/Es-ist-so-einfach3.2996bd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Es-ist-so-einfach3.jpg
// module id = 245
// module chunks = 8